module.exports = __webpack_public_path__ + "img/law1.e97f3f70.webp";